import { createRouter as createVueRouter, createWebHistory, createMemoryHistory } from 'vue-router';
import LoginCallback from '@/components/Auth/LoginCallback.vue';
import Logout from '@/components/Auth/Logout.vue';
import RouteHandler from './RouteHandler.vue';
import LoginRedirect from './components/Auth/LoginRedirect.vue';

// support languages in the URL prefix
// e.g. /da-DK/path, or /en/path, or /path
export const routePatterns = [
  '/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute(.*)*',
  '/:lang([a-z]{2})/:sitecoreRoute(.*)*',
  '/:sitecoreRoute(.*)*',
];

export function createRouter(isSSR: boolean) {
  // create an instance of vue-router and configure routes to use the RouteHandler component
  return createVueRouter({
    history: isSSR ? createMemoryHistory() : createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
      return new Promise((resolve) => {
        setTimeout(() => {
          if (to.hash) {
            resolve({
              el: to.hash,
              behavior: 'smooth',
            });
          } else if (savedPosition) {
            resolve(savedPosition);
          } else {
            resolve({ top: 0 });
          }
        }, 500);
      });
    },
    routes: [
      { path: process.env.VUE_APP_ENTRA_CALLBACK as string, component: LoginCallback },
      { path: process.env.VUE_APP_ENTRA_REDIRECT as string, component: LoginRedirect },
      { path: '/logout', component: Logout },
      ...routePatterns.map((routePattern) => {
        return {
          path: routePattern,
          component: RouteHandler,
          props: (route: any) => ({
            route,
          }),
        };
      }),
    ],
  });
}
